import { useState, useEffect } from "react";
import { Button, Select, TextInput } from "flowbite-react";

/**
 * Widget configuration section.
 * Shows 3 widget slots that can be mapped to metric definitions.
 * Pre-populated by auto-setup, editable by user.
 */
export const WidgetConfig = ({
  widgetConfig,
  metricDefinitions,
  widgetSaving,
  onSave,
}) => {
  const [localConfig, setLocalConfig] = useState({
    widget_1: { metric_id: null, display_name: "" },
    widget_2: { metric_id: null, display_name: "" },
    widget_3: { metric_id: null, display_name: "" },
  });

  useEffect(() => {
    if (widgetConfig) {
      setLocalConfig({
        widget_1: {
          metric_id: widgetConfig.widget_1_metric || null,
          display_name: widgetConfig.widget_1_display_name || "",
        },
        widget_2: {
          metric_id: widgetConfig.widget_2_metric || null,
          display_name: widgetConfig.widget_2_display_name || "",
        },
        widget_3: {
          metric_id: widgetConfig.widget_3_metric || null,
          display_name: widgetConfig.widget_3_display_name || "",
        },
      });
    }
  }, [widgetConfig]);

  const handleChange = (widgetKey, field, value) => {
    const coerced = field === "metric_id" && value === "" ? null : value;
    setLocalConfig((prev) => ({
      ...prev,
      [widgetKey]: { ...prev[widgetKey], [field]: coerced },
    }));
  };

  return (
    <div>
      <h3 className="mb-2 text-lg font-semibold text-gray-900">
        Dashboard Widgets
      </h3>
      <p className="mb-4 text-sm text-gray-500">
        Choose which metrics appear in the 3 widget slots on customer usage
        pages.
      </p>

      <div className="space-y-3">
        {[1, 2, 3].map((num) => {
          const key = `widget_${num}`;
          return (
            <div key={key} className="flex items-center gap-3">
              <span className="w-16 text-sm font-medium text-gray-500">
                Slot {num}
              </span>
              <Select
                className="flex-1"
                value={localConfig[key]?.metric_id || ""}
                onChange={(e) => handleChange(key, "metric_id", e.target.value)}
              >
                <option value="">Select metric</option>
                {metricDefinitions.map((metric) => (
                  <option key={metric.id} value={metric.id}>
                    {metric.display_name}
                  </option>
                ))}
              </Select>
              <TextInput
                className="flex-1"
                placeholder="Display name"
                value={localConfig[key]?.display_name || ""}
                onChange={(e) =>
                  handleChange(key, "display_name", e.target.value)
                }
              />
            </div>
          );
        })}
      </div>

      <Button
        color="blue"
        className="mt-4"
        size="sm"
        onClick={() => onSave(localConfig)}
        disabled={widgetSaving}
        isProcessing={widgetSaving}
      >
        Save Widget Config
      </Button>
    </div>
  );
};
